import { useNavigate } from 'react-router-dom';
import CardRefundOrder from '@/domains/mobile-web/components/CardRefundOrder/CardRefundOrder';
import TopBarHeader from '@/domains/mobile-web/components/TopBarHeader/TopBarHeader';
import {
  REFUND_PRODUCT_LEBAH,
  REFUND_REJECTION_REASONS,
  REFUND_STATIC,
} from '@/domains/mobile-web/constant/refund.constant';
import WrapperMobile from '@/shared/components/layout/WrapperMobile/WrapperMobile';
import HeaderMobile from '@/shared/components/ui/HeaderMobile/HeaderMobile';

const RefundRejected = () => {
  const navigate = useNavigate();

  return (
    <main className="min-h-screen">
      <HeaderMobile>
        <TopBarHeader type="back" onBack={() => navigate(-1)} title="Pengajuan Refund" />
      </HeaderMobile>

      <WrapperMobile className="mb-6">
        <CardRefundOrder
          date={REFUND_STATIC.date}
          status="rejected"
          code={REFUND_STATIC.refundCode}
          products={[REFUND_PRODUCT_LEBAH]}
        />

        <article className="shadowCard flex w-full flex-col gap-3 bg-white p-3">
          <h3 className="title2medium text-black">Alasan Penolakan</h3>
          <ol className="list-decimal flex flex-col gap-2 pl-5 body1 text-black">
            {REFUND_REJECTION_REASONS.map((text) => (
              <li key={text}>{text}</li>
            ))}
          </ol>
        </article>
      </WrapperMobile>
    </main>
  );
};

export default RefundRejected;
